import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, ShieldCheck, MessageSquare, Lock, FileSignature, Scale, Mic, Laptop, Award, TrendingUp } from 'lucide-react';
const modules = [{
  icon: <Laptop className="w-6 h-6" data-id="element-168" />,
  title: 'IA Jurídica Aplicada',
  desc: 'Herramientas y prompts para optimizar tu trabajo diario.'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-169" />,
  title: 'Compliance y Gestión de Riesgos',
  desc: 'Estrategias preventivas para empresas y organizaciones.'
}, {
  icon: <MessageSquare className="w-6 h-6" data-id="element-170" />,
  title: 'Argumentación Jurídica Estratégica',
  desc: 'Técnicas avanzadas para construir casos sólidos.'
}, {
  icon: <Lock className="w-6 h-6" data-id="element-171" />,
  title: 'Protección de Datos y Privacidad',
  desc: 'Marco legal y aplicación práctica en la era digital.'
}, {
  icon: <FileSignature className="w-6 h-6" data-id="element-172" />,
  title: 'Redacción Contractual Profesional',
  desc: 'Cláusulas, estructuras y modelos de contratos modernos.'
}, {
  icon: <Scale className="w-6 h-6" data-id="element-173" />,
  title: 'Responsabilidad Civil Práctica',
  desc: 'Análisis y cuantificación de daños en casos reales.'
}, {
  icon: <Mic className="w-6 h-6" data-id="element-174" />,
  title: 'Litigación Oral y Audiencias',
  desc: 'Técnicas de persuasión y manejo de audiencias.'
}, {
  icon: <Laptop className="w-6 h-6" data-id="element-175" />,
  title: 'Prueba Digital y Evidencia Electrónica',
  desc: 'Recolección y validación de pruebas en entornos digitales.'
}, {
  icon: <Award className="w-6 h-6" data-id="element-176" />,
  title: 'Ética Profesional',
  desc: 'Resolución de dilemas éticos en la práctica moderna.'
}, {
  icon: <TrendingUp className="w-6 h-6" data-id="element-177" />,
  title: 'Gestión y Crecimiento del Estudio Jurídico',
  desc: 'Sistemas, procesos y marketing para escalar tu práctica.'
}];
export const Modules = () => {
  return <section className="py-20 bg-legal-800 border-y border-legal-700" data-id="element-178">
      <div className="container mx-auto px-4" data-id="element-179">
        <div className="text-center mb-16 max-w-3xl mx-auto" data-id="element-180">
          <span className="inline-block text-gold-500 font-semibold tracking-widest uppercase text-sm mb-4" data-id="element-181">
            10 Módulos Profesionales
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-182">
            ¿Qué incluye el Megapack?
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-183">
            10 módulos diseñados para cubrir todas las áreas de la práctica
            profesional moderna.
          </p>
        </div>

        <div className="max-w-4xl mx-auto space-y-4" data-id="element-184">
          {modules.map((mod, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.08
        }} className="group flex gap-5 md:gap-6 bg-legal-900 border border-legal-700 hover:border-gold-500/50 rounded-xl p-6 md:p-7 transition-colors" data-id="element-185">
              {/* Number + icon */}
              <div className="shrink-0 flex flex-col items-center" data-id="element-186">
                <span className="font-serif text-4xl md:text-5xl font-bold text-gold-500/30 leading-none group-hover:text-gold-500/60 transition-colors" data-id="element-187">
                  {String(idx + 1).padStart(2, '0')}
                </span>
                <span className="mt-3 flex items-center justify-center w-11 h-11 rounded-lg bg-gold-500/10 text-gold-500" data-id="element-188">
                  {mod.icon}
                </span>
              </div>

              <div className="border-l border-legal-700 pl-5 md:pl-6" data-id="element-189">
                <span className="text-xs font-semibold tracking-widest uppercase text-gold-500/80" data-id="element-190">
                  Módulo {idx + 1}
                </span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-1 mb-2 leading-snug" data-id="element-191">
                  {mod.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-192">{mod.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};